import { Button } from "@mui/material";
import { forwardRef } from "react";

export const DialogHeaderStyle = {
  position: "sticky",
  top: 0,
  backgroundColor: "var(--header-color)",
  zIndex: 1,
  pt: 2,
  pl: 2,
  pr: 2,
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
};

export const DialogBottomStyle = {
  position: "sticky",
  bottom: 0,
  // top: 50,
  backgroundColor: "var(--header-color)",
  zIndex: 999,
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
};

export const CustomMuiButton = forwardRef(
  ({ variant, onClick, label, height }) => (
    <Button
      variant={variant}
      onClick={onClick}
      sx={{
        height: height,
        backgroundColor:
          variant === "contained" ? "var(--contained-btn-bg)" : "initial",
        color:
          variant === "contained"
            ? "var(--contained-btn-color)"
            : "var(--contained-btn-bg)",
        border:
          variant === "outlined"
            ? `1px solid var(--contained-btn-bg)`
            : "initial",
        "&:hover": {
          backgroundColor:
            variant === "contained" ? "var(--contained-btn-hover)" : "initial",
        },
      }}
    >
      {label}
    </Button>
  )
);

//report paper style
export const PaperShadowStyle = {
  p: 1,
  width: "100%",
  boxShadow:
    "2px 2px 4px rgba(0, 0, 0, 0.12), -1px -1px 1px rgba(0, 0, 0, 0.14), 1px 2px 1px -1px rgba(0, 0, 0, 0.20)",
};

// search 또는 filter 모달 style
export const filterModalStyle = {
  width: "fit-content",
  height: "fit-content",
  bgcolor: "var(--modal-color)",
  borderRadius: "4px",
  padding: "10px 12px 5px 12px",
};
